import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
export default {
  name: 'MdmSelect',
  components: {
    MdmIcon: MdmIcon
  },
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultState: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // new in 2.2 https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
    inputListeners: function inputListeners() {
      var _this = this;

      return _objectSpread({}, this.$listeners, {
        input: function input(event) {
          return _this.$emit('input', event.target.value);
        },
        focus: function focus() {
          return _this.$emit('focus');
        }
      });
    },
    selected: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  }
};